// 一些全局常量
export default {
  OSS_HOST: 'https://ihealthy.oss-cn-shenzhen.aliyuncs.com/'
}
